export const LocalStorageKeys = {
  analyticsUser: 'analyticsUser',
  token: 'token',
  version: 'version',
}
